import React, { Component } from "react";
import "./CreateModal.styles.scss";
import EscapeOutside from "react-escape-outside";

import BounceLoader from "react-spinners/BounceLoader";
import FadeLoader from "react-spinners/FadeLoader";
import axios from "axios";

import picture from "./_image/picture.svg";
import close_green_corner from "./_image/close_green_corner.svg";
import close_button from "./_image/close_button.svg";
import Dropdown from "./Dropdown/Dropdown";
//import MomentUtils from "@date-io/moment";
import DateFnsUtils from "@date-io/date-fns";
//import moment from "moment";
import { format } from "date-fns";
import { store } from "react-notifications-component";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import districts from "./content/districts";
import divisions from "./content/divisions";
import { normalizeString } from "../utils/normalizeString";
import checkValidity from "../utils/validityCheckForSubmitting";
import { Collapse } from "@mui/material";

const userTags = [
  { name: "MMO", id: "1" },
  { name: "MAO", id: "2" },
];

// import { useNotification } from "../../../../../Notifications/NotificationProvider";

const Modal = ({ handleClose, show, children }) => {
  return (
    <div className={show ? "modal display-block" : "modal display-none"}>
      <EscapeOutside
        onEscapeOutside={() => {
          console.log("");
        }}
      >
        <div className="wrapper-modal">
          <section className="modal-main" style={{ width: 568 }}>
            {children}
          </section>
        </div>
      </EscapeOutside>
    </div>
  );
};

class CreateModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      spots: [],
      agency: [],
      areas: [],
      territories: [],
      regions: [],
      clusters: [],
      createdZone: {},
      errorMessages: [],
    };
  }

  componentDidMount() {
    this.loadZonesForDropDown("spots");
    this.loadZonesForDropDown("agency");
    this.loadZonesForDropDown("areas");
    this.loadZonesForDropDown("territories");
    this.loadZonesForDropDown("regions");
    this.loadZonesForDropDown("clusters");
    // this.loadFSE()
  }

  componentDidUpdate(prevProps) {
    // if (this.props.selectedZone["id"] !== prevProps.selectedZone["id"])
    //   this.loadZonesForDropDown(this.props.selectedZone["id"]);
  }

  loadZonesForDropDown = (zone) => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/organizations/api/v1/${zone}`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        this.setState({
          agencies: res.data.data,
          [zone]: res.data.data,
        });
      })
      .catch((err) => console.log(err));
  };

  handleZoneName = (e) => {
    // console.log(e.target.value);
    e.preventDefault();
    this.setState({
      createdZone: {
        ...this.state.createdZone,
        name: e.target.value,
      },
    });
    this.setState({ errorMessages: [] });
  };

  handleZoneCode = (e) => {
    //console.log(e.target.value);
    e.preventDefault();
    this.setState({
      createdZone: {
        ...this.state.createdZone,
        code: e.target.value,
      },
    });
    this.setState({ errorMessages: [] });
  };

  handleZoneMAWallet = (e) => {
    //console.log(e.target.value);
    e.preventDefault();
    this.setState({
      createdZone: {
        ...this.state.createdZone,
        ma_wallet: e.target.value,
      },
    });
    this.setState({ errorMessages: [] });
  };

  hideModal = () => {
    this.props.handleHide();
    this.setState({ createdZone: {}, errorMessages: [] });
  };

  handleZone = (e) => {
    this.setState({
      createdZone: {
        ...this.state.createdZone,
        [`${this.props.selectedZone["parentId"]}_id`]: e.id,
      },
    });
    this.setState({ errorMessages: [] });
  };
  handleUserTagChange = (e) => {
    console.log(e);
    this.setState({
      createdZone: {
        ...this.state.createdZone,
        user_tag: e.name,
      },
    });
    this.setState({ errorMessages: [] });
  };
  handleDistrictChange = (e) => {
    this.setState({
      createdZone: {
        ...this.state.createdZone,
        district: e.target.value,
      },
    });
    this.setState({ errorMessages: [] });
  };

  handleThanaChange = (e) => {
    this.setState({
      createdZone: {
        ...this.state.createdZone,
        thana: e.target.value,
      },
    });
    this.setState({ errorMessages: [] });
  };

  handleDivisionChange = (e) => {
    this.setState({
      createdZone: {
        ...this.state.createdZone,
        division: e.name,
      },
    });
    this.setState({ errorMessages: [] });
  };

  submitForCreating = () => {
    const errorMsg = checkValidity(
      { ...this.state.createdZone },
      this.props.selectedZone["id"]
    );
    this.setState({ errorMessages: errorMsg });
    if (errorMsg.length > 0) return;

    this.setState({ loading: true });
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/organizations/api/v1/${this.props.selectedZone["id"]}`,
        { ...this.state.createdZone },
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        console.log("success");
        alert(
          `Successfully created ${this.props.selectedZone["createId"]} : ${this.state.createdZone["name"]} `
        );
        this.loadZonesForDropDown(this.props.selectedZone["id"]);
        this.setState({ loading: false });
        this.hideModal();
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
        this.hideModal();
      });
  };

  render() {
    return (
      <section className="mdocreate-section">
        <Modal
          show={this.props.show}
          onEscapeOutside={() => {
            console.log("");
          }}
        >
          <div className="modal-header">
            <div className="headline">
              <div className="main-headline">
                Create {normalizeString(this.props.selectedZone["createId"])}
              </div>
              <div className="sub-headline">
                Fill in the details and press Submit
              </div>
            </div>
            {/* <div className="close-button-corner" onClick={this.close_clear}>
              <img className="corner" src={close_green_corner} alt="close" />
              <img className="cross" src={close_button} alt="close" />
              <button className="button--close" onClick={this.props.handleHide}>
                X
              </button>
            </div> */}
          </div>
          <div className="modal-body"></div>

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <form>
              <div className="group">
                <input
                  value={
                    this.state.createdZone["name"]
                      ? this.state.createdZone["name"]
                      : ""
                  }
                  onChange={this.handleZoneName}
                  // placeholder={this.props.name}
                  type="text"
                  required="required"
                  // defaultValue={this.state.name}
                />
                <span className="highlight"></span>
                <span className="bar"></span>
                <label>New {this.props.selectedZone["createId"]} name</label>
              </div>
              {(this.props.selectedZone["id"] === "spots" ||
                this.props.selectedZone["id"] === "agency") && (
                <div className="group">
                  <input
                    value={
                      this.state.createdZone["code"]
                        ? this.state.createdZone["code"]
                        : ""
                    }
                    onChange={this.handleZoneCode}
                    // placeholder={this.props.name}
                    type="text"
                    required="required"
                    // defaultValue={this.state.name}
                  />
                  <span className="highlight"></span>
                  <span className="bar"></span>
                  <label>Code</label>
                </div>
              )}
              {this.props.selectedZone["id"] === "agency" && (
                <div className="group">
                  <input
                    value={
                      this.state.createdZone["ma_wallet"]
                        ? this.state.createdZone["ma_wallet"]
                        : ""
                    }
                    onChange={this.handleZoneMAWallet}
                    // placeholder={this.props.name}
                    type="text"
                    required="required"
                    // defaultValue={this.state.name}
                  />
                  <span className="highlight"></span>
                  <span className="bar"></span>
                  <label>MA Wallet</label>
                </div>
              )}

              {this.props.selectedZone["id"] !== "clusters" && (
                <Dropdown
                  className="dd-cmdo"
                  title={`Select ${this.props.selectedZone["parentPlaceHolder"]}`}
                  items={this.state[this.props.selectedZone["parentId"]]}
                  searchable
                  onChange={this.handleZone}
                  reset={this.props.reset}
                />
              )}
              {this.props.selectedZone["id"] === "spots" && (
                <Dropdown
                  className="dd-cmdo"
                  title={`User tag`}
                  items={userTags}
                  onChange={this.handleUserTagChange}
                  searchable={false}
                  reset={this.props.reset}
                />
              )}
              {this.props.selectedZone["id"] !== "regions" &&
              this.props.selectedZone["id"] !== "clusters" ? (
                <div className="group">
                  <input
                    value={
                      this.state.createdZone["district"]
                        ? this.state.createdZone["district"]
                        : ""
                    }
                    onChange={this.handleDistrictChange}
                    // placeholder={this.props.name}
                    type="text"
                    required="required"
                    // defaultValue={this.state.name}
                  />
                  <span className="highlight"></span>
                  <span className="bar"></span>
                  <label>Select District</label>
                </div>
              ) : (
                <Dropdown
                  className="dd-cmdo"
                  title={`Select division`}
                  items={divisions}
                  onChange={this.handleDivisionChange}
                  searchable
                  reset={this.props.reset}
                />
              )}
              {(this.props.selectedZone["id"] === "agency" ||
                this.props.selectedZone["id"] === "spots") && (
                <div className="group">
                  <input
                    value={
                      this.state.createdZone["thana"]
                        ? this.state.createdZone["thana"]
                        : ""
                    }
                    onChange={this.handleThanaChange}
                    // placeholder={this.props.name}
                    type="text"
                    required="required"
                    // defaultValue={this.state.name}
                  />
                  <span className="highlight"></span>
                  <span className="bar"></span>
                  <label>Select Thana</label>
                </div>
              )}
            </form>
          </MuiPickersUtilsProvider>

          <Collapse in={this.state.errorMessages.length > 0}>
            <div className="error-container">
              {this.state.errorMessages.map((msg) => {
                return (
                  <p>
                    <b>{msg}</b> <i>is not filled up</i>
                  </p>
                );
              })}
            </div>
          </Collapse>

          <div className="footer">
            <BounceLoader
              className="loader"
              color={"#e2136e"}
              size={20}
              loading={this.state.loading}
            />

            {this.state.error_submitting && !this.state.loading ? (
              <span className="footer-error-msg">
                {/* {this.state.error_msg} */}
                Failed to add MDO
              </span>
            ) : null}

            <button className="button--cancel" onClick={this.hideModal}>
              {" "}
              Cancel{" "}
            </button>
            <button
              disabled={this.state.loading}
              className="button--save"
              onClick={this.submitForCreating}
            >
              {this.state.loading ? "Creating" : "Create"}
            </button>
          </div>
        </Modal>
      </section>
    );
  }
}

export default CreateModal;
